import { cn } from "@/shared/lib/cn";
import paceteqLogo from "@/assets/paceteqLogo.png";

interface AppNavigationRailBrandProps {
  collapsed: boolean;
}

export function AppNavigationRailBrand({
  collapsed,
}: AppNavigationRailBrandProps) {
  return (
    <div
      className={cn(
        "group flex items-center justify-center transition-all duration-300",
        collapsed ? "w-14 duration-800" : "w-full"
      )}
    >
      <img
        src={paceteqLogo}
        alt="PACETEQ"
        className={cn(
          "h-auto pt-4 object-contain transition-all duration-300",
          collapsed ? "w-11" : "w-full max-w-[150px]"
        )}
      />
    </div>
  );
}
